import { render, staticRenderFns } from "./numberRanking.vue?vue&type=template&id=4b141f59&scoped=true&"
import script from "./numberRanking.vue?vue&type=script&lang=js&"
export * from "./numberRanking.vue?vue&type=script&lang=js&"
import style0 from "./numberRanking.vue?vue&type=style&index=0&id=4b141f59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b141f59",
  null
  
)

export default component.exports